import Seller from "./From/Seller";
import Invoice from "./Invoice";
import Payment from "./Payment";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import classNames from "classnames";
import Discount from "./Discount";
import Buttons from "./Buttons";
import List from './List';
import isEqual from "lodash-es/isEqual";
import connect from "react-redux/es/connect/connect";
import Button from "../../../form/Button";
import Modal from "../../../layout/Modal";
import ConsignmentReportList from "../../lists/ConsignmentReportList";
import ComponentConfig from "../../../form/ComponentConfig";
import ConsignmentReportForm from "../../forms/ConsignmentReportForm";
import VatRate from "./VatRate";
import Other from "./Other";
import ComponentLoader from "../../../form/ComponentLoader";
import Tabs from "../../../layout/Tabs";
import TabContent from "../../../layout/TabContent";

class ConsignmentPurchaseForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: false,
            changeConfirm: false,
            selectedConsignmentReports: (this.props.props.values.xtradata || {}).reports || [],
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual((this.props.props.values.xtradata || {}).reports, (prevProps.props.values.xtradata || {}).reports)) {
            this.setState({
                selectedConsignmentReports: (this.props.props.values.xtradata || {}).reports || [],
            });
        }
    }

    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        return <Fragment>
            <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
            <Editor
                theme="default"
                footer={<Fragment>
                    <Buttons {...componentProps} />
                </Fragment>}
            >
                {
                    props.values.id && <form onSubmit={props.handleSubmit}>
                        <div className="row form-row">
                            <div className="col-md-10">
                                <Seller {...componentProps} />
                            </div>
                            <div className="col-md-2">
                                <label className="control-label">&nbsp;</label>
                                <Button
                                    color="primary"
                                    disabled={!props.values.seller}
                                    block={true}
                                    onClick={() => {
                                        this.setState({opened: true});
                                    }}
                                >
                                    Riport(ok) kiválasztása
                                </Button>
                                {props.values.seller && <Fragment>
                                    <Modal
                                        header="Biztos?"
                                        state={this.state.changeConfirm}
                                        buttons={[
                                            {
                                                text: "Mégse",
                                                props: {color: "default", disabled: props.disabled || props.isLoading},
                                                onClose: true,
                                                onClick: async () => {
                                                    try {
                                                        this.setState({changeConfirm: false});
                                                    } catch (e) {

                                                    }
                                                }
                                            },
                                            {
                                                text: "Igen",
                                                props: {color: "warning", disabled: props.disabled || props.isLoading || !(this.state.selectedConsignmentReports && !!this.state.selectedConsignmentReports.length)},
                                                onClick: async () => {
                                                    try {
                                                        await componentProps.setSelectedReports(this.state.selectedConsignmentReports);
                                                        this.setState({
                                                            selectedConsignmentReports: this.state.selectedConsignmentReports,
                                                            opened: false,
                                                            changeConfirm: false
                                                        }, () => {
                                                            this.pool && this.pool.refresh();
                                                        });
                                                    } catch (e) {
                                                        console.error(e);
                                                    }
                                                }
                                            }
                                        ]}
                                    >
                                        A kiválaszott riportok nem egyeznek az eddig kiválasztottakkal, ha elfogadod a tételek felül lesznek írva!<br/>
                                        Biztos ezt akarod?
                                    </Modal>
                                    <Modal
                                        header="Riport kiválasztása"
                                        state={this.state.opened}
                                        size={"large"}
                                        {...props}
                                        disabled={props.disabled || props.isLoading}
                                        buttons={[
                                            {
                                                text: "Mégse",
                                                props: {color: "default", disabled: props.disabled || props.isLoading},
                                                onClose: true,
                                                onClick: async () => {
                                                    try {
                                                        this.setState({selectedConsignmentReports: (this.props.props.values.xtradata || {}).reports || [], opened: false, changeConfirm: false});
                                                    } catch (e) {

                                                    }
                                                }
                                            },
                                            {
                                                text: "Kiválasztás",
                                                props: {color: "primary", disabled: props.disabled || props.isLoading || !(this.state.selectedConsignmentReports && !!this.state.selectedConsignmentReports.length)},
                                                onClick: async () => {
                                                    if (!(isEqual((this.props.props.values.xtradata || {}).reports, this.state.selectedConsignmentReports) ||!(this.props.props.values.xtradata || {}).reports)) {
                                                        this.setState({changeConfirm: true});
                                                    } else {
                                                        try {
                                                            await componentProps.setSelectedReports(this.state.selectedConsignmentReports);
                                                            this.setState({
                                                                selectedConsignmentReports: this.state.selectedConsignmentReports,
                                                                opened: false,
                                                                changeConfirm: false
                                                            }, () => {
                                                                this.pool && this.pool.refresh();
                                                            });
                                                        } catch (e) {
                                                            console.error(e);
                                                        }
                                                    }
                                                }
                                            }
                                        ]}
                                    >
                                        <div className="form-group">
                                            <label className="control-label">Riport(ok)</label>
                                            <ComponentConfig componentName="ConsignmentReport">
                                                <ConsignmentReportList
                                                   filter={[
                                                       {field: "consignor", value: props.values.seller.partner_id},
                                                       {field: "consignee", value: props.values.customer.partner_id},
                                                       {field: "state", value: 30, operator: "<"}
                                                   ]}
                                                   selection={this.state.selectedConsignmentReports || []}
                                                   selectionMode="multiple"
                                                   loadForm={(selectedConsignmentReports) => {
                                                       if (selectedConsignmentReports) {
                                                           this.setState({selectedConsignmentReports: selectedConsignmentReports.map((item) => item.id).sort((a,b) => a-b)});
                                                       } else {
                                                           this.setState({selectedConsignmentReports: []});
                                                       }
                                                   }}
                                                />
                                            </ComponentConfig>
                                        </div>
                                        {
                                            this.state.selectedConsignmentReports && !!this.state.selectedConsignmentReports.length &&
                                            <div className="form-group">
                                                <Tabs
                                                    defaultTab={this.state.selectedConsignmentReports[0]}
                                                    theme="default"
                                                >
                                                    {
                                                        this.state.selectedConsignmentReports.map((reportId, idx) => {
                                                            return <TabContent
                                                                key={idx}
                                                                tabLabel={"#" + reportId + " Riport"}
                                                                tabName={reportId}
                                                            >
                                                                <ComponentConfig componentName="ConsignmentReport">
                                                                    <ComponentLoader
                                                                        componentName="ConsignmentReport"
                                                                        componentId={reportId}
                                                                        componentAs="values"
                                                                        view="admin"
                                                                    >
                                                                        <ConsignmentReportForm
                                                                            getFieldProps={() => ({disabled: true})}
                                                                        />
                                                                    </ComponentLoader>
                                                                </ComponentConfig>
                                                            </TabContent>;
                                                        })
                                                    }
                                                </Tabs>
                                            </div>
                                        }
                                    </Modal>
                                </Fragment>
                                }
                            </div>
                        </div>
                        <Invoice {...componentProps} />
                        <div className="row form-row">
                            <Payment {...componentProps} />
                        </div>
                        <Comment {...componentProps} />
                        <div className="row form-row">
                            <div className="col-md-12">
                                <Discount {...componentProps} />
                            </div>
                            {/*<div className="col-md-2">
                                <ImportButton {...props.getFieldProps("import")} data={props.values} disabled={!props.values[props.componentConfig.idfield]} componentConfig={props.componentConfig} label={<Fragment>&nbsp;</Fragment>} name="file" saveChanges={() => {}} />
                            </div>*/}
                        </div>
                        <PoolList
                            ref={(pool) => this.pool = pool}
                            {...componentProps}
                            control={{visible: false}}
                        />
                        <Other {...componentProps} tag={Fragment} />
                    </form>
                }
            </Editor>
        </Fragment>;
    }
}


export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(ConsignmentPurchaseForm);